<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
             <v-slide-x-reverse-transition>
                <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
                <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success }}</v-alert>
            </v-slide-x-reverse-transition>
            <v-row >
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายการใบเสร็จขาย</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
                    <section class="d-flex justify-space-between">
                        <v-row>
                            <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="title_page">
                                <div class="font-16">รายการรับเงินเข้าวันนี้</div>
                            </v-col>
                            <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                                <div class="mt-1">
                                    <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </section>

                    <section class="pa-3">
                        <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0" >
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>
                                    <div class="font-16">{{dataDetail.item.invoice_code}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.updated_at }} </div>
                                </td>
                                <td>
                                    <div v-if="dataDetail.item.credit_charge_status == 1 && dataDetail.item.pay_type.find(o => o === 3)" class="font-16">{{formatPrice(parseFloat(dataDetail.item.total) + (parseFloat(dataDetail.item.total) * parseFloat(dataDetail.item.credit_charge) / 100))}}</div>
                                    <div v-else class="font-16">{{formatPrice(dataDetail.item.total)}}</div>
                                </td>
                                <td>
                                    <div v-for="detail in dataDetail.item.pay_type" :key="detail.id" class="font-16">{{detail == 1 ? 'เงินสด' :detail == 2 ? 'เงินโอน' : detail == 3 ? 'บัตรเครดิต':detail == 4 ? 'อื่น ๆ': detail == 5 ? 'QR Code' : 'ยังไม่ได้จ่าย'}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.user_cancel ? dataDetail.item.user_cancel : '-'}}</div>
                                </td>
                                <td>
                                    <span v-if="dataDetail.item.status != 2">
                                        <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#EC6162" title="ยกเลิกบิล"
                                            style="border-radius:10px" @click="open_model_cancel(), cancel.invoice_id = dataDetail.item.id, user_cancel = dataDetail.item.user_cancel" >ยกเลิกบิล
                                        </v-btn>
                                    </span>  
                                    <span v-else style="color:#EC6162;">
                                        บิลถูกยกเลิก
                                    </span>  
                                </td>
                                <td>
                                    <div class="d-flex">
                                        <span>
                                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                                                style="border-radius:10px" @click="getDetail(dataDetail.item.id) ,user_cancel = dataDetail.item.user_cancel" >
                                                <v-icon>mdi-magnify</v-icon>ดูรายละเอียด
                                            </v-btn>
                                        </span>  
                                        <span>
                                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                                                style="border-radius:10px" @click="open_model_print_bill(), status_invoice_tax = dataDetail.item.tax_invoice_id, status_invoice_refund = dataDetail.item.tax_refund_id, id=dataDetail.item.id, vat_type=dataDetail.item.vat_type, bill_status = dataDetail.item.status , is_vat = dataDetail.item.is_vat">
                                                <v-icon>mdi-printer</v-icon> พิมพ์
                                            </v-btn>
                                        </span>                  
                                    </div>
                                </td>
                            </tr>

                        </template>
                        </v-data-table>
                    </section>
                </v-card>
            </div>

            <!-- รายละเอียด -->
            <v-dialog v-if="show_detail_bill" v-model="show_detail_bill" persistent max-width="650px" >
                <v-card class="input-radius">
                    <v-card-title class="d-flex  pt-2">
                        <v-row>
                            <v-col cols="12 text-right pt-5 pb-1 ">
                                <v-btn icon class="ma-1" @click="close_model_all()">
                                    <v-icon color="grey">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                            
                            <v-col cols="12 pt-1">
                                <v-col v-if="user_cancel != null" class="border-bill-red input-radius">
                                    <div class="required--text">
                                        สาเหตุการยกเลิกบิล : {{detailList.invoice.cancel_note}}
                                    </div>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-container class="pa-7 border-bill input-radius">
                            <v-row>
                                <v-col cols="4" class="title_page_right pr-0 pt-0">
                                    <v-img height="88" width="88" :src="seller.logo_pos" :lazy-src="seller.logo_pos"></v-img>
                                </v-col>
                                <v-col cols="7 text-center pl-0 pt-0">
                                    <div class="font-16">
                                       {{seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name}}
                                    </div>
                                    <div class="font-16">
                                        TAX#{{seller.store_personal_id}} (VAT Includ)
                                    </div>
                                    <div class="font-16">
                                        POS {{ seller.posid }}
                                    </div>
                                    <div class="font-16">
                                        ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ
                                    </div>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="6">
                                   <div class="font-16">{{detailList.invoice.invoice_code}}</div> 
                                </v-col>
                                <v-col cols="6 text-right">
                                   <div class="font-16">{{detailList.invoice.created_at != null ? `${detailList.invoice.created_at.split('-')[2].split(' ')[0]}/${detailList.invoice.created_at.split('-')[1]}/${detailList.invoice.created_at.split('-')[0]} @ ${detailList.invoice.created_at.split('-')[2].split(' ')[1]}` : '-'}}</div> 
                                </v-col>
                                <v-col cols="12 pt-0 pb-1">
                                    <div class="border-style-b pb-2 px-4"></div>
                                </v-col>
                            </v-row>
                           <div id="bot" class="mt-5">
      <div id="table">
        <table>
          <tr class="tabletitle">
            <td class="font-13 item " style="width:10px !important;"><h2>Item</h2></td>
            <td class="font-13 text-center"><h2>ราคา</h2></td>
            <td class="font-13 text-center"><h2>จำนวน</h2></td>
            <td class="font-13 text-right"><h2>รวม</h2></td>
          </tr>

          <tr v-for="(item, index) in detailList.invoice_list" :key="index" class="service">
            <td class="tableitem  font-13">
              <p class="itemtext pr-2 mt-5">{{ item.product_name }}</p>
              <p class=" pr-2 mt-5 font-10 text-center" v-if="item.discount > 0">ส่วนลด {{item.product_name}}</p>
            </td>
            <td class="tableitem font-13 text-center va-top">
              <p class="itemtext mt-5">{{ formatPrice(item.price) }}</p>
              <br v-if="item.discount > 0">
            </td>
            <td class="tableitem font-13 text-center va-top">
              <p class="itemtext mt-5" v-if="item.product_code == null">-{{ item.qty }}</p>
              <p class="itemtext mt-5" v-else>{{ item.qty }}</p>
              <br v-if="item.discount > 0">
            </td>
            <td class="tableitem font-13 text-right va-top">
              <p class="itemtext mt-5" v-if="item.product_code == null">-{{ formatPrice(parseFloat(item.total)+parseFloat(item.discount)) }}</p>
              <p class="itemtext mt-5" v-else>{{ formatPrice(parseFloat(item.total)+parseFloat(item.discount)) }}</p>
              <p class="itemtext mt-5"  v-if="item.discount > 0">-{{ formatPrice(item.discount) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="border-style-b pb-2 px-4"></div>
            </td>
          </tr>

     

          <tr class="tabletitle">
            <td><p class="mt-5 font-13">มูลค่าสินค้า</p></td>
            <td class="mt-5 font-13"></td>
            <td><p class="mt-5 font-13 text-center">{{total_qty}} ชิ้น</p></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice(total_price) }}</p></td>
          </tr>
          <tr class="tabletitle">
            <td><p class="mt-5 font-13">ส่วนลดท้ายบิล</p></td>
            <td></td>
            <td><p class="mt-5 font-13"></p></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice(detailList.invoice.discount) }}</p></td>
          </tr>
          <tr class="tabletitle">
            <td><p class="mt-5 font-13">ภาษีมูลค่าเพิ่ม 7%</p></td>
            <td></td>
            <td></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice(detailList.invoice.vat) }}</p></td>
          </tr>
          <tr class="tabletitle" v-if="detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3)">
            <td><p class="mt-5 font-13">เครดิตชาร์ต  {{parseFloat(detailList.invoice.credit_charge)}}% </p></td>
            <td></td>
            <td></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice((parseFloat(detailList.invoice.total) * parseFloat(detailList.invoice.credit_charge / 100))) }}</p></td>
          </tr>
          <tr class="tabletitle">
            <td><p class="mt-5 font-13">ยอดเงินสุทธิ </p></td>
            <td></td>
            <td></td>
            <td v-if="detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3)" class="text-right"><p class="mt-5 font-13">{{ formatPrice(parseFloat(detailList.invoice.total) + (parseFloat(detailList.invoice.total) * parseFloat(detailList.invoice.credit_charge / 100))) }}</p></td>
            <td v-else class="text-right"><p class="mt-5 font-12">{{ formatPrice(parseFloat(parseFloat(detailList.invoice.total))) }}</p></td>
          </tr>
          <tr class="tabletitle">
            <td><p class="mt-5 font-13">รับเงิน </p></td>
            <td></td>
            <td></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice(parseFloat(detailList.invoice.cash)+parseFloat(detailList.invoice.payment)+parseFloat(detailList.invoice.credit)+parseFloat(detailList.invoice.etc_payment)+parseFloat(detailList.invoice.qrcode_pay)) }}</p></td>
          </tr>
          <tr class="tabletitle">
            <td><p class="mt-5 font-13">เงินทอน </p></td>
            <td></td>
            <td></td>
            <td class="text-right"><p class="mt-5 font-12">{{ formatPrice(parseFloat(detailList.invoice.change)) }}</p></td>
          </tr>

          <tr>
            <td colspan="4" v-if="seller.status_main_store != 1">
              <div class="color-gray-mid font-10 mt-10"> * สาขา{{ seller.store_name}} {{seller.tel}} *</div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
             <div class="border-style-b pb-2 px-4"></div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class=" font-12 "> ข้อมูลสมาชิก {{detailList.invoice.member_name}} </div>
            </td>
          </tr>
          <br>
          <tr>
            <td class="item"></td>
            <td>
              <p class="font-12 text-center">ได้รับ</p> 
            </td>
            <td>
              <p class="font-12 text-center">ใช้ไป</p> 
            </td>
            <td>
              <p class="font-12 text-center">คงเหลือ</p> 
            </td>
          </tr>

          <tr>
            <td>
              <p class="font-12 mt-5">แต้มสมาชิก</p> 
            </td>
            <td>
              <p class="font-12 text-center mt-5">+{{detailList.invoice.member_name == null ? formatPrice(0) : formatPrice(detailList.invoice.point)}}</p> 
            </td>
            <td>
              <p class="font-12 text-center mt-5">{{formatPrice(detailList.invoice.use_point)}}</p> 
            </td>
            <td>
              <p class="font-12 text-center mt-5">{{formatPrice(detailList.invoice.point_remain)}}</p> 
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray-mid font-10 mt-4 "> ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ ** </div>
            </td>
          </tr>

        </table>
      </div><!--End Table-->

      <div id="legalcopy" class="text-center">
        <p class="font-14">  ขอบคุณที่ใช้บริการ </p>
      </div>
    </div><!--End InvoiceBot-->
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- ปุ่มยกเลิก -->
            <v-dialog v-model="show_cancel_bill" persistent max-width="600px" >
                <v-card class="input-radius pa-5">
                    <v-card-title>
                        <v-row>
                            <v-col class="pt-4">
                                <div class="bold font-20">ยกเลิกใบเสร็จ</div>
                            </v-col>
                            <v-col class="text-right">
                                <v-btn icon class="ma-1" @click="close_model_all()">
                                    <v-icon color="grey">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                      
                            <v-row>
                                <v-col cols="12">
                                    <v-checkbox v-model="cancel.check" label="ต้องการนำสินค้าคืนคลัง" color="#D6BFAF"  hide-details> </v-checkbox>
                                </v-col>
                                <v-col cols="12" @click="toggleCheckbox()" >
                                    <label label class="label_form_text">สาเหตุการยกเลิกใบเสร็จ <span class="required--text">*</span></label>
                                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto" v-model="cancel.note"
                                    placeholder="กรุณากรอกสาเหตุการยกเลิกใบเสร็จ" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined dense maxlength="255"
                                    required>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                                    <label label class="label_form_text">เบอร์โทรเข้าสู่ระบบ <span class="required--text">*</span></label>
                                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account" hide-details="auto" v-model="cancel.tel"
                                     placeholder="กรุณากรอกเบอร์โทรเข้าสู่ระบบ" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined dense
                                    required>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                                    <label label class="label_form_text">รหัสผ่าน <span class="required--text">*</span></label>
                                    <v-text-field label="รหัสผ่าน" class="input-radius" prepend-inner-icon="mdi-lock" v-model="cancel.password" color="#D6BFAF"
                                    hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                                    @click:append="show = !show" single-line outlined dense required></v-text-field>
                                </v-col>
                                <v-col cols="12 text-right">
                                    <div class="text-right mt-5">
                                        <v-btn @click="saveCancelInvoice()" type="submit" height="45" width="150" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">ยกเลิกบิล</v-btn>
                                    </div>
                                </v-col>
                               
                            </v-row>
                    
                    </v-card-text>

                </v-card>
            </v-dialog>

            <!-- Modal การแจ้งเตือนเสร็จสิ้น -->
            <v-dialog v-model="show_check_bill_success" persistent max-width="500px" >
                <v-card class="input-radius pa-5">
                    <v-card-title>
                        <v-row>
                            <v-col class="text-right py-0">
                                <v-btn icon class="ma-1" @click="close_model_all()">
                                    <v-icon color="grey">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10">
                        <v-row>
                            <v-col cols="12 title_page_center">
                                <div class="text-center">
                                    <v-img width="178" class="w-100" :src="img_check" ></v-img>
                                </div>
                            </v-col>
                            <v-col cols="12 text-center">
                               <h1 class=""> ยกเลิกใบเสร็จสำเร็จ </h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="show_print_bill" persistent max-width="650px" >
                <v-card class="input-radius pa-5">
                    <v-card-title>
                        <v-row>
                            <v-col cols="">
                                <div class="bold font-20">เลือกใบเสร็จที่ต้องการปริ้น</div>
                            </v-col>
                            <v-col class="text-right py-0">
                                <v-btn icon class="ma-1" @click="close_model_all()">
                                    <v-icon color="grey">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="4 px-2">
                                <v-card class="input-radius" elevation="2">
                                    <v-row>
                                        <v-col cols="12 title_page_center pt-7">
                                            <v-img width="70" height="70" :lazy-src="img_bill" :src="img_bill"></v-img>
                                        </v-col>
                                        <v-col cols="12 pt-0">
                                            <div class="text-center">ใบเสร็จอย่างย่อ</div>
                                        </v-col>
                                    </v-row>
                                    <v-card-actions class="text-center title_page_center">
                                        <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์" @click="linkPage()"
                                            style="border-radius:10px">
                                            <v-icon>mdi-printer</v-icon> พิมพ์
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col cols="4 px-2">
                                <v-card class="input-radius" elevation="2">
                                    <v-row>
                                        <v-col cols="12 title_page_center pt-7">
                                            <v-img width="70" height="70" :lazy-src="img_billpayment" :src="img_billpayment"></v-img>
                                        </v-col>
                                        <v-col cols="12 pt-0">
                                            <div class="text-center">ใบแจ้งหนี้/ใบกำกับภาษี</div>
                                        </v-col>
                                    </v-row>
                                    <v-card-actions class="text-center title_page_center">
                                        <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                                            style="border-radius:10px" @click="status_invoice_tax == null ? link('/arin/pos/posinvoicestaxadd/'+id) : link('/arin/pos/pospapertaxinvoices?id='+id)" :disabled="Number(bill_status) === 2 || Number(is_vat) === 0">
                                            <v-icon>mdi-printer</v-icon> พิมพ์
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col cols="4 px-2">
                                <v-card class="input-radius" elevation="2">
                                    <v-row>
                                        <v-col cols="12 title_page_center pt-7">
                                            <v-img width="70" height="70" :lazy-src="img_tax" :src="img_tax"></v-img>
                                        </v-col>
                                        <v-col cols="12 pt-0">
                                            <div class="text-center">ใบ Tax Refund</div>
                                        </v-col>
                                    </v-row>
                                    <v-card-actions class="text-center title_page_center">
                                        <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                                            style="border-radius:10px" @click="status_invoice_refund == null ? link('/arin/pos/posinvoicestaxrefundadd/'+id) : ''" :disabled="Number(bill_status) === 2 || Number(is_vat) === 0">
                                            <v-icon>mdi-printer</v-icon> พิมพ์
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
            <div v-if="print_receipt" class="d-none">
            <iframe :src="'/arin/pos/posinvoicereceipt?id='+id+'&vat_status='+vat_type" title="print_receipt"></iframe>
        </div>
        </div>
    </div>
</template>
  
<script>

import img_arin from "@/assets/arin_assets/arin.png";
import img_check from "@/assets/arin_assets/check_success.png";
import img_bill from "@/assets/arin_assets/bill.png";
import img_billpayment from "@/assets/arin_assets/billpayment.png";
import img_tax from "@/assets/arin_assets/tax_two.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";

export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_bill_sale",
    data() {
        return {
            loading_page: false,
             alert_error:false,
            alert_message_error:null,
            alert_success:false,
            alert_message_success:null,
            dialog_cancel_order: false,
            search: '',
            tab_id: 1,
            show_detail_bill: false,
            show: false,
            show_cancel_bill: false,
            show_check_bill_success:false,
            show_print_bill:false,
            img_arin: img_arin,
            img_check: img_check,
            img_bill: img_bill,
            img_billpayment: img_billpayment,
            img_tax: img_tax,

            checkbox_cancel_import: false,
            note_cancel_import:null,
            tel_login:null,
            password:null,

            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },
            headers : [
                { 
                    text: 'เลขที่ใบเสร็จ',
                    value: 'invoice_code',
                    fixed: true,
                    width: '130px'
                },
                { 
                    text: 'เวลา',
                    value: 'receipt_date',
                    fixed: true,
                    width: '160px'
                },
                { 
                    text: 'ยอดขาย',
                    value: 'receipt_price',
                    fixed: true,
                    width: '130px'
                },
                { 
                    text: 'การชำระเงิน',
                    value: 'receipt_pay',
                    fixed: true,
                    width: '150px'
                },
                { 
                    text: 'ผู้ยกเลิก',
                    value: 'receipt_cancel',
                    fixed: true,
                    width: '200px'
                },
                { 
                    text: 'สถานะ',
                    value: 'receipt_status',
                    fixed: true,
                    width: '150px'
                },
                { 
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    width: '120px'
                },
            ] ,
            data_list : [],
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'การขาย',
                    disabled:false,
                },
                {
                    text:'แสดงบิลขาย',
                    disabled:false,
                },
            ],
             cancel:{
                invoice_id: null,
                check: false,
                note: null,
                tel: null,
                password: null,
            },
            detailList:  [],
            total_qty:  null,
            total_price:  null,
            print_receipt: false,
            vat_type: null,
            invoice_id: null,
            user_cancel: null,
            id: null,
            status_invoice_tax: null,
            status_invoice_refund: null,
            bill_status: null,
            seller: {},
             vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ"
        }
    }, 
    methods: {
        async linkPage(){
            this.print_receipt = false;
            this.print_receipt = true;
      },
         truncateString(product_name) {
                    var maxLength = 10;
                    var truncatedString = '';
                    var characterCount = 0;

                    for (var i = 0; i < product_name.length; i++) {
                        var character = product_name[i];
                        truncatedString += character;

                        if (this.vowelCharacters.indexOf(character) === -1) {
                            characterCount++;
                        }

                        if (characterCount >= maxLength) {
                            break;
                        }
                    }

                    if (product_name.length > maxLength) {
                        truncatedString += "...";
                    }

                    product_name = truncatedString;
                    return product_name
                },
        link(link){
            window.location.href = link;
        },
        formatPrice(number){
            return formatPrice(number)
        },
        open_model_bill(){
            this.show_detail_bill = true
        },
        open_model_cancel(){
            this.show_cancel_bill = true
        },
        open_model_bill_success(){
            this.show_check_bill_success = true
        },
        open_model_print_bill(){
            this.print_receipt = false
            this.show_print_bill = true
            // Debug: ดูค่าจริงของ bill_status และ is_vat
            console.log('bill_status:', this.bill_status, 'type:', typeof this.bill_status)
            console.log('is_vat:', this.is_vat, 'type:', typeof this.is_vat)
        },
        close_model_all(){
            this.show_detail_bill = false
            this.show_cancel_bill = false
            this.show_check_bill_success = false
            this.show_print_bill = false
            this.print_receipt = false
        },
        async Invoice_all(){
             let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                let id = this.$route.params.id;
               await HTTP_ARIN.get(`/pos/round/invoicelist/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                       this.data_list = res.data.invoiceList
                       this.data_list = this.data_list.map(item => {
                            return {
                                ...item,
                                updated_at: item.updated_at.split(' ')[1],
                            }
                        })
                    }
                })
        },
        async  getSotre(){
             let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let store_id = this.$store.state.store_arin.user_data.store_id;
            await HTTP_ARIN.get('/stores/detail/'+store_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.seller = res.data.storeDetail;
                }
            })
        },
         async saveCancelInvoice(){
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                this.print_receipt = false
                let data = {
                    status_return_product: this.cancel.check == true ? 1 : 0,
                    cancel_note: this.cancel.note,
                    tel: this.cancel.tel,
                    password: this.cancel.password,
                };
               await HTTP_ARIN.post(`/pos/invoice/cancle/${this.cancel.invoice_id}`, data, config).then((res) => {
                    if (res.data.successful === true) {
                        this.cancel.invoice_id = null
                        this.cancel.check = false
                        this.cancel.note = null
                        this.cancel.tel = null
                        this.cancel.password = null
                        this.show_cancel_bill = false
                        this.show_check_bill_success = true
                        this.id = this.cancel.invoice_id
                        this.print_receipt = true
                        this.Invoice_all()
                    }else if(res.data.successful === false){
                         this.alert_error = true
                        this.alert_message_error = 'เบอร์โทรหรือรหัสผ่านไม่ถูกต้อง'
                        setTimeout(() => this.alert_error = false, 5000)
                    }
                })
        },
         async getDetail(id){
            this.total_qty = 0
            this.total_price = 0
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
               await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.detailList = res.data.data
                         this.detailList.invoice_list.forEach((detail) => {
                          this.total_qty += parseFloat(detail.qty)
                          this.total_price += parseFloat(detail.total)
                          this.getSotre()
                          this.open_model_bill()
                        })
                    }
                })
        },

    },
    mounted(){
        this.Invoice_all()
    }

}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 100%; */
}
.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 45px;
    padding: 0 10px;
}
.border-bill{
    border: 1px solid #F0F0F0;
}

.border-bill-red{
    border: 1px solid #EC6162;
}
.border-style-b {
    /* border-style: dotted;
    border-color: #ADADAD; */
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px dotted #ADADAD;
}
.title_page_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title_page_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}
#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #FFF;
}
::selection {
  background: #f31544;
  color: #FFF;
}
::moz-selection {
  background: #f31544;
  color: #FFF;
}
h1 {
  font-size: 1.5em;
  color: #000000;
}
h2 {
  font-size: 1.2em;
}
h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}
p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
}

#top {
  min-height: 100px;
}
#mid {
  min-height: 80px;
}
#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
}
.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}
.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}
.title {
  float: right;
}
.title p {
  text-align: right;
}
table {
  width: 100%;
  border-collapse: collapse;
}
td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}
.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}
.service {
  border-bottom: 0px solid #EEE;
}
.item {
  width: 40mm;
}
.item-med {
  width: 15mm;
}
.itemtext {
  font-size: 0.9em;
}
.Rate {
  font-size: 0.9em;
}
.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}
.flex-center{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pr-5{
  padding-right:5px ;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.w-100{
  width: 100%;
}
.color-gray{
  color: #000000;
}
.color-gray-mid{
  color: #000000;
}
.va-top{
  vertical-align: top;
}
.mt-10{
  margin-top:10px ;
}
.mt-5{
  margin-top:7px ;
}
.mt-4{
  margin-top:4px ;
}
.font-12{
  font-size: 14px;
}
.font-13{
  font-size: 14px;
}
</style>
  